<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="抄表项名称" prop="itemName">
              <a-input placeholder="请输入抄表项名称" v-model="model.itemName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="简称" prop="itemShortName">
              <a-input :disabled="!!model.id" placeholder="请输入简称" v-model="model.itemShortName"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="详情" prop="itemDesc">
              <a-input placeholder="请输入详情" v-model="model.itemDesc"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="点号" prop="pointCode">
              <a-input disabled placeholder="请输入点号" v-model="model.pointCode"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工艺" prop="devProcessId">
              <j-dict-select-tag
                dictCode="`iwt-wf`.dev_process,process_name,id"
                placeholder="请选择工艺"
                type="list"
                v-model="model.devProcessId"
              />
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="设备" prop="devId">
              <j-dict-select-tag dictCode placeholder="请选择设备" type="list" v-model="model.devId" />
            </a-form-model-item>
          </a-col>-->
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数据来源" prop="sensorReadSource">
              <j-dict-select-tag
                dictCode="sensor_read_source"
                placeholder="数据来源"
                type="radioButton"
                v-model="model.sensorReadSource"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item
              :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
              :wrapperCol="{xs: { span: 24 },sm: { span: 20 }}"
              label="计算公式"
              prop="expression"
            >
              <a-textarea placeholder="请输入计算公式" rows="4" v-model="model.expression" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单位" prop="dataUnit">
              <a-input placeholder="请输入单位" v-model="model.dataUnit"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="排序" prop="sort">
              <a-input-number placeholder="请输入排序" style="width: 100%" v-model="model.sort" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'IotSensorReadItemForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
          sensorReadSource: 'write'
        },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          sensorReadSource: [
            { required: true, message: '请选择数据来源!' },
          ],
          itemName: [
            { required: true, message: '请输入抄表项名称!' },
          ],
          itemShortName: [
            { required: true, message: '请输入简称!' },
            { pattern: /^[A-Za-z_0-9]{0,}$/, message: '只能输入字母数字和下划线!' },
          ],
        },
        url: {
          add: "/read/item/add",
          edit: "/read/item/edit",
          queryById: "/read/item/queryById"
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    watch: {
      'model.itemShortName' (newVal, oldVal) {
        this.model.pointCode = `t_sensor_${this.$ls.get('TENANT_ID')}_${newVal}`.toLowerCase();
      },
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning('简称用于计算，不可重复，请更换简称');
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>